import { render, staticRenderFns } from "./Fees.vue?vue&type=template&id=2d691ef4&scoped=true&"
import script from "./Fees.vue?vue&type=script&lang=js&"
export * from "./Fees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d691ef4",
  null
  
)

export default component.exports